/* global CONFIG */
const { apiUrl, apiVersion } = CONFIG;

const baseApiUrl = `${apiUrl}/api/${apiVersion}`;

export { baseApiUrl };
